"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$CustomerResponseDto = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
exports.$CustomerResponseDto = {
    properties: {
        id: {
            type: 'string',
        },
        address: {
            type: 'StripeAddress',
        },
        balance: {
            type: 'number',
        },
        cash_balance: {
            type: 'StripeCashBalance',
        },
        created: {
            type: 'number',
        },
        currency: {
            type: 'string',
            isNullable: true,
        },
        default_source: {
            type: 'one-of',
            contains: [{
                    type: 'string',
                }, {
                    type: 'StripeCustomerSource',
                }],
            isNullable: true,
        },
        deleted: {
            type: 'boolean',
            isNullable: true,
        },
        delinquent: {
            type: 'boolean',
            isNullable: true,
        },
        description: {
            type: 'string',
            isNullable: true,
        },
        discount: {
            type: 'StripeDiscount',
        },
        email: {
            type: 'string',
            isNullable: true,
        },
        invoice_credit_balance: {
            type: 'dictionary',
            contains: {
                type: 'number',
            },
        },
        invoice_prefix: {
            type: 'string',
            isNullable: true,
        },
        invoice_settings: {
            type: 'CustomerInvoiceSettings',
        },
        livemode: {
            type: 'boolean',
        },
        metadata: {
            type: 'StripeMetadata',
        },
        name: {
            type: 'string',
            isNullable: true,
        },
        next_invoice_sequence: {
            type: 'number',
            isNullable: true,
        },
        phone: {
            type: 'string',
            isNullable: true,
        },
        preferred_locales: {
            type: 'array',
            contains: {
                type: 'string',
            },
            isNullable: true,
        },
        shipping: {
            type: 'CustomerShipping',
        },
        sources: {
            type: 'ApiListStripeCustomerSource',
        },
        subscriptions: {
            type: 'ApiListStripeSubscription',
        },
        tax: {
            type: 'CustomerTax',
        },
        tax_exempt: {
            type: 'CustomerTaxExempt',
        },
        tax_ids: {
            type: 'ApiListStripeTaxId',
        },
        test_clock: {
            type: 'one-of',
            contains: [{
                    type: 'string',
                }, {
                    type: 'StripeTestClock',
                }],
            isNullable: true,
        },
    },
};
